<template>
  <div class="flex align-center sorter">
    <div
      class="sorter-item"
      :class="`${sorterParams.sort ? '' : 'text-orange'}`"
      @click="chooseOneSorter(false)"
    >
      综合排序
    </div>
    <div
      v-for="item in sorterArr"
      :key="item.sort"
      class="sorter-item"
      @click="chooseOneSorter(item)"
    >
      <span :class="`${sorterParams.sort === item.sort ? 'text-orange' : ''}`">
        {{item.text}}
      </span>
      <i
        class="el-icon-sort-down"
        style="margin-right: -6px;"
        :class="`${(sorterParams.sort === item.sort) && (sorterParams.direction === 'desc') ? 'text-orange' : ''}`"
      ></i>
      <i
        class="el-icon-sort-up"
        :class="`${(sorterParams.sort === item.sort) && (sorterParams.direction === 'asc') ? 'text-orange' : ''}`"
      ></i>
    </div>
  </div>
</template>

<script>
import { isEmpty } from 'lodash';

export default {
  components: {
  },
  data() {
    return {
      sorterArr: [
        {
          sort: 1,
          text: '上架时间',
        },
        {
          sort: 2,
          text: '价格',
        },
      ],
      sorterParams: {},
    };
  },
  methods: {
    chooseOneSorter(item) {
      if ((item.sort === this.sorterParams.sort && item.direction) === (this.sorterParams.direction)) {
        return;
      }
      if (!item) {
        this.sorterParams = {};
        this.$emit('search');
        return;
      }
      if (item.sort !== this.sorterParams.sort) {
        // 选了另一个筛选项
        this.sorterParams = {
          sort: item.sort,
          direction: 'desc',
        }
      } else {
        // 同一个筛选项，更换筛选顺序
        this.sorterParams = {
          sort: item.sort,
          direction: this.sorterParams.direction === 'desc' ? 'asc' : 'desc',
        }
      }
      this.$emit('search');
    },

    getSortParams() {
      if (isEmpty(this.sorterParams)) {
        return {
          sort: 0,
        }
      }
      return this.sorterParams;
    }
  },

}

</script>

<style lang='scss' scoped>
.sorter {
  .sorter-item {
    cursor: pointer;
    &:not(:last-child) {
      margin-right: 12px;
    }
  }
}
</style>
